import script from "./menu-lateral-templates.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-lateral-templates.vue?vue&type=script&setup=true&lang=js"

import "./menu-lateral-templates.vue?vue&type=style&index=0&id=29dcf160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dcf160"]])

export default __exports__